import { FC, ReactNode, useCallback, useState } from "react";
import { Icons, TranslationProvider, Wallets, useTranslation } from "rujira.ui";
import { Link } from "../../Gate";
import { useAccounts } from "../../services/accounts";
import { WALLETS } from "../wallets";

/** Keeps the transaction draft mounted while another wallet is connected. */
export const TransferSession: FC<{
  children: (connect: () => void) => ReactNode;
}> = ({ children }) => {
  const [connecting, setConnecting] = useState(false);
  const connect = useCallback(() => setConnecting(true), []);
  const provider = useAccounts();
  const { t } = useTranslation("common");

  return (
    <>
      <div hidden={connecting}>{children(connect)}</div>
      {connecting && (
        <TranslationProvider namespace="header">
          <button
            type="button"
            className="transfer-modal__back transparent color-grey hover-white flex ai-c mb-2 pointer"
            onClick={() => setConnecting(false)}>
            <Icons.AngleLeft className="block w-2 h-2 mr-0.5" />
            {t("back")}
          </button>
          <Wallets
            modalLayout
            provider={provider}
            wallets={WALLETS}
            routingElement={Link}
            onConnectSuccess={() => setConnecting(false)}
          />
        </TranslationProvider>
      )}
    </>
  );
};
